import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import Header from '../components/Header';
import Footer from '../components/Footer';

import { API_URL } from '../utils/apiUrl';

function formatPhoneInput(value) {
  const digits = value.replace(/\D/g, '');
  let d = digits;
  if (d.startsWith('0') || d.startsWith('9')) d = d.replace(/^(90|0)/, '');
  if (d.length > 10) d = d.slice(0, 10);
  if (!d.startsWith('5') && d.length > 0) return d.slice(0, 0);
  return d;
}

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', subject: '', message: '', website: '',
  });
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      const formatted = formatPhoneInput(value);
      setFormData(prev => ({ ...prev, phone: formatted }));
      const digits = formatted.replace(/\D/g, '');
      if (digits.length > 0 && !digits.startsWith('5')) {
        setPhoneError('Telefon numarası 5 ile başlamalıdır');
      } else {
        setPhoneError('');
      }
      return;
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const digits = formData.phone.replace(/\D/g, '');
    if (digits.length !== 10 || !digits.startsWith('5')) {
      toast.error('Telefon numarası 10 haneli olmalı ve 5 ile başlamalıdır (5XXXXXXXXX)');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/contact`, { ...formData, phone: digits });
      toast.success('Mesajınız başarıyla alındı. En kısa sürede sizinle iletişime geçeceğiz.');
      setFormData({ name: '', phone: '', email: '', subject: '', message: '', website: '' });
    } catch (err) {
      // Show server validation detail for known input errors; generic message otherwise
      const detail = err.response?.data?.detail;
      if (err.response?.status === 400 && detail) {
        toast.error(detail);
      } else {
        toast.error('Mesaj gönderilirken bir sorun oluştu. Lütfen tekrar deneyin.');
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h2 className="text-4xl md:text-5xl font-black tracking-tight mb-6" data-testid="contact-title">İletişim</h2>
        <p className="text-base text-neutral-500 mb-12 leading-relaxed">
          Sorularınız veya önerileriniz için bize ulaşabilirsiniz.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-bold mb-2" htmlFor="name">Ad Soyad *</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required
              className="w-full border border-neutral-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#1C3B2A] transition" data-testid="input-name" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-bold mb-2" htmlFor="phone">Telefon * <span className="font-normal text-neutral-400">(5XXXXXXXXX)</span></label>
              <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required
                placeholder="5XXXXXXXXX" maxLength={10}
                className={`w-full border px-4 py-3 rounded-md focus:outline-none transition ${phoneError ? 'border-red-400 focus:border-red-500' : 'border-neutral-300 focus:border-[#1C3B2A]'}`}
                data-testid="input-phone" />
              {phoneError && <p className="text-xs text-red-500 mt-1" data-testid="phone-error">{phoneError}</p>}
            </div>
            <div>
              <label className="block text-sm font-bold mb-2" htmlFor="email">E-posta <span className="font-normal text-neutral-400">(opsiyonel)</span></label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange}
                className="w-full border border-neutral-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#1C3B2A] transition" data-testid="input-email" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-bold mb-2" htmlFor="subject">Konu *</label>
            <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required
              className="w-full border border-neutral-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#1C3B2A] transition" data-testid="input-subject" />
          </div>
          <div>
            <label className="block text-sm font-bold mb-2" htmlFor="message">Mesaj *</label>
            <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows="6"
              minLength={10} maxLength={5000}
              className="w-full border border-neutral-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#1C3B2A] transition" data-testid="input-message" />
          </div>
          {/* Honeypot — real users don't see this; bots often fill every field */}
          <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}>
            <label htmlFor="website">Website</label>
            <input type="text" id="website" name="website" tabIndex={-1} autoComplete="off"
              value={formData.website} onChange={handleChange} />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-[#1C3B2A] text-white px-8 py-4 font-bold text-sm tracking-wide hover:bg-[#152e21] transition disabled:opacity-50 rounded-md"
            data-testid="submit-button">
            {loading ? 'GÖNDERİLİYOR...' : 'MESAJ GÖNDER'}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
